import React, { FunctionComponent, useEffect } from 'react';

import Calculator from './Components/Calculator';
import CategoriesOfferContextProvider from './context/CategoriesOfferContext';

const App: FunctionComponent<{
  customer: string;
  modal?: string;
  title?: string;
  subtitle?: string;
  testttt?: string;
}> = ({ customer, modal, title, subtitle }) => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      const linkElem = document.createElement('link');
      linkElem.setAttribute('rel', 'stylesheet');
      const link = window.location.href.includes('vercel.app')
        ? `/static/css/main.css`
        : `https://painting-frontend.vercel.app/static/css/main.css`;
      linkElem.setAttribute('href', link);
      const parents = document.getElementsByTagName('hemfixare-calculator');
      if (parents.length) {
        parents[0]?.shadowRoot?.append(linkElem);
      }
    }
  }, []);

  return (
    <div id="calculator-app" className="App">
      <CategoriesOfferContextProvider>
        <Calculator
          customer={customer}
          isModal={Boolean(modal)}
          title={title}
          subtitle={subtitle}
        />
      </CategoriesOfferContextProvider>
    </div>
  );
};

export default App;
